module.exports = __webpack_public_path__ + "img/12.3f90b0d9.jpg";